import { render, staticRenderFns } from "./GoalStep.vue?vue&type=template&id=7bdc0501&scoped=true"
import script from "./GoalStep.vue?vue&type=script&lang=js"
export * from "./GoalStep.vue?vue&type=script&lang=js"
import style0 from "./GoalStep.vue?vue&type=style&index=0&id=7bdc0501&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bdc0501",
  null
  
)

export default component.exports